import color from 'tinycolor2'

export const darken = (c: string, amt: number) =>
  color(c).darken(amt).toString()

export const lighten = (c: string, amt: number) =>
  color(c).lighten(amt).toString()

export const isLight = (c: string) => {
  return color(c).isLight()
}

export const getRGBA = (c: string) => {
  return color(c).toRgbString().replace(')', '').replace('rgb(', '')
}
